/**
 * MarketingNav — top navigation for the public marketing site.
 *
 * Mounted by Landing, Pricing, Privacy, About, and other public routes.
 * Order per product-copy spec §5.1: Product · Pricing · Privacy · About · Sign in
 * Primary action: Book a Demo.
 */
import { Link, useLocation } from "react-router-dom";
import Brand from "./Brand";
import LanguageSwitcher from "./LanguageSwitcher";
import { useI18n } from "../lib/i18n";

const NAV_LINKS = [
  { label: "Product", href: "/#solution", testid: "marketing-nav-product" },
  { label: "Pricing", href: "/pricing", testid: "marketing-nav-pricing" },
  { label: "Privacy", href: "/privacy", testid: "marketing-nav-privacy" },
  { label: "About", href: "/about", testid: "marketing-nav-about" },
];

export default function MarketingNav() {
  const location = useLocation();
  const { t } = useI18n();
  return (
    <header className="absolute top-0 left-0 right-0 z-30 px-6 sm:px-10 pt-6">
      <div className="mx-auto max-w-7xl flex items-center justify-between">
        <Link to="/" aria-label="Alouvya home" data-testid="marketing-nav-home">
          <Brand size="md" dataTestId="brand-marketing-nav" />
        </Link>
        <nav
          aria-label="Primary"
          className="hidden md:flex items-center gap-7"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className={
                "text-sm font-medium transition-colors " +
                (location.pathname === l.href
                  ? "text-[#1A1B2E]"
                  : "text-[#6B7280] hover:text-[#1A1B2E]")
              }
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/signin"
            data-testid="marketing-nav-signin"
            className="text-sm font-medium text-[#6B7280] hover:text-[#1A1B2E]"
          >
            {t("auth.sign_in")}
          </Link>
          <LanguageSwitcher testid="marketing-language-switcher" compact />
          <Link
            to="/demo"
            data-testid="marketing-nav-demo"
            className="ml-2 inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-[#1F3A2A] text-white text-sm font-semibold hover:bg-[#132C17] transition-colors"
          >
            {t("landing.cta.book_demo")}
          </Link>
        </nav>
        {/* Mobile — compact CTA only */}
        <Link
          to="/demo"
          data-testid="marketing-nav-demo-mobile"
          className="md:hidden inline-flex items-center px-4 py-2 rounded-full bg-[#1F3A2A] text-white text-sm font-semibold"
        >
          {t("landing.cta.book_demo")}
        </Link>
      </div>
    </header>
  );
}
